import React, { useEffect } from 'react';
import { getLocale} from 'umi';
import './index.scss';
import { List } from 'tea-component';
import { shortcutOptionContrast } from './utils';
import { LANGUAGE_EN } from '@home/_config/config';
import { getLanguage } from '@home/utils/common';

interface CustomDivElement extends HTMLDivElement {
  setPopActive: () => void;
}

interface IProps {
  startDate: string; // 统计日期（起始）
  endDate: string; // 统计日期（结束）
  dateRange: number; // 统计日期范围
  type:string; // 日期粒度
  handleChangeValue: Function;
  setSelectLeftType: Function;
  childRef: React.RefObject<CustomDivElement>; 
  selectedLeftType: string;
  isSameRange:boolean; // 日期范围是否一致
}

const RangePickerContrastDate = (props: IProps) => {
  const {
    endDate,
    startDate,
    dateRange,
    type,
    handleChangeValue,
    setSelectLeftType,
    childRef,
    selectedLeftType,
    isSameRange
  } = props;
  const isEn = getLocale() === LANGUAGE_EN;

  const commonDataList = shortcutOptionContrast(startDate, endDate, dateRange)?.[type];

  useEffect(() => {
    if (!isSameRange) {
      setSelectLeftType('');
    }
  }, [isSameRange, setSelectLeftType]);

  return (
    <div className="dbd-rangepicker-contrast-left">
      <List type="option" className="dbd-common-box">
        {commonDataList.map((item) => (
          <List.Item className={`dbd-common-box-item ${selectedLeftType === item?.name && 'dbd-rangepicker-shortcut-hover'}`}
            key={''}
            onClick={() => {
              handleChangeValue(item?.onClick(), type);
              setSelectLeftType(item);
              //  关闭时间组件弹出窗
              childRef?.current?.setPopActive();
            }}>
            {getLanguage(isEn, item?.name, item?.nameCN)}
          </List.Item>
        ))}
      </List>
    </div>
  );
};

export default RangePickerContrastDate;
